import { Typography } from '@bw/alloy-react';
import React from 'react';

const ExpressHeader: React.FC = () => {
  return (
    <div
      className="text-center d-flex flex-column gap-4"
      data-bw="express-header"
    >
      <Typography
        color="white"
        tag="h1"
        className="largeTitle"
        style={{ fontSize: 'clamp(2.5rem, 10vw, 4.5rem)', lineHeight: 1.2 }}
      >
        Ready. Set. Go.
      </Typography>
      <Typography color="white" variant="h3">
        Your ideas, our network.{' '}
        <span style={{ display: 'inline-block' }}>Let&apos;s get started.</span>
      </Typography>
    </div>
  );
};

export default ExpressHeader;
